export enum ActionType {
  CREATE = 1,
  UPDATE = 2,
  DELETE = 3,
}

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}
